<template>
  <vue-link v-if="item.link" :to="item.link" :class="['AboutThumb', template]">
    <article>
      <h2><span :class="['a-hover']" v-html="item.title"></span></h2>
      <div class="copy" v-html="item.text"></div>
    </article>
    <div
      v-if="thumbnailUrl && block"
      class="image"
      v-lazy:background-image="thumbnailUrl"
    ></div>
    <LazyImage
      v-else-if="thumbnailUrl"
      :image="thumbnail"
      size="medium"
      :zoom="true"
    ></LazyImage>
  </vue-link>
  <div v-else :class="['AboutThumb', template]">
    <article>
      <h2>
        <span :class="['a-hover']">{{ item.title }}</span>
      </h2>
      <div class="copy" v-html="item.text"></div>
    </article>
    <div
      v-if="thumbnailUrl && block"
      class="image"
      v-lazy:background-image="thumbnailUrl"
      :key="thumbnailUrl"
    ></div>
    <LazyImage
      v-else-if="thumbnailUrl"
      :image="thumbnail"
      size="medium"
      :zoom="true"
    ></LazyImage>
  </div>
</template>

<script>
import delve from "dlv";
import VueLink from "./VueLink.js";
import LazyImage from "./Image";

export default {
  name: "AboutThumb",
  components: { VueLink, LazyImage },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    template: {
      type: String,
      default: "block",
    },
  },
  computed: {
    thumbnailUrl() {
      return (
        delve(this.item, "image.sizes.medium_large") ||
        delve(this.item, "image.url")
      );
    },
    thumbnail() {
      return this.item.image;
    },
    block() {
      return this.template === "block";
    },
    row() {
      return this.template === "row";
    },
  },
};
</script>

<style scoped>
/**
 * Block: default
 */

.AboutThumb.block {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.AboutThumb.block > article {
  order: 1;
}
.AboutThumb.block > .image {
  order: 0;
}

.AboutThumb.block > article {
  text-align: center;
}

.AboutThumb.block h2 {
  display: inline-block;
  text-align: center;
  margin-bottom: 1em;
  /*text-decoration: underline;*/
  /*border-bottom: 1px solid #000;*/
}

.AboutThumb.block h2 span {
  border-bottom: 1px solid #000;
  /*text-shadow: -1px -1px #fff, -1px 1px #fff, 1px -1px #fff, 1px 1px #fff;*/
  /*box-shadow: inset 0 -1px #fff, inset 0 -2px #000;*/
}

.AboutThumb.block p {
  text-align: left;
}

.AboutThumb.block > .image {
  padding-top: 56%;
  background-size: cover;
  background-position: center;
  margin-bottom: 1rem;
}

/**
 * Row
 */

.AboutThumb.row {
  overflow: hidden;
}

.AboutThumb.row:not(:first-child) {
  border-top: 1px solid #000;
}

.AboutThumb.row > article {
  width: 75%;
  padding-right: 2rem;
  float: left;
}

.AboutThumb.row > figure {
  width: 25%;
  float: left;
  text-align: center;
}

.AboutThumb.row > figure >>> img {
  max-width: min(100%, var(--intrinsic-width, 100%));
}

.AboutThumb.row h2 {
  font: var(--large);
  margin-bottom: 2rem;
}

@media (max-width: 1000px) {
  .AboutThumb.row h2 {
    /*font: var(--medium);*/
    /*text-decoration: underline;*/
  }
}
</style>
